// extracted by mini-css-extract-plugin
module.exports = {"a8ii0rv":"a8ii0rv"};